const branch = process.env['VERCEL_GIT_COMMIT_REF'] || 'dev'

export const isVercelApp =
  typeof window !== 'undefined' && window.location.origin.includes('vercel')

export const isNative =
  typeof window !== 'undefined' &&
  (!!window.location.origin.includes('capacitor') ||
    !!window.location.origin.includes('localhost'))

const getTokenEnvironment = () => {
  let envString = 'preview'

  if (branch.includes('staging')) {
    envString = branch
  }

  if (branch.includes('main')) {
    envString = branch
  }

  return envString
}

export const getBearerSetter = () => {
  return 'flectoBearer_' + getTokenEnvironment()
}

export const getIdTokenSetter = () => {
  return 'flectoIdToken_' + getTokenEnvironment()
}

function getCookie(name: string) {
  try {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    const cookiePart = parts.pop()
    return cookiePart ? cookiePart.split(';').shift() : ''
  } catch {
    return ''
  }
}

export const writeStoreToken = (bearer: string, idToken?: string) => {
  const bearerName = getBearerSetter()
  const idTokenName = getIdTokenSetter()
  const LOCALSTORAGE_SAAS_TOKEN = `${getTokenEnvironment()}_bearer_token`
  const LOCALSTORAGE_ID_TOKEN = `${getTokenEnvironment()}_id_token`

  if (bearer) {
    document.cookie = `${bearerName}=${bearer};path=/;domain=flecto.io`
    localStorage.setItem(LOCALSTORAGE_SAAS_TOKEN, bearer)
  }

  if (idToken) {
    document.cookie = `${idTokenName}=${idToken};path=/;domain=flecto.io`
    localStorage.setItem(LOCALSTORAGE_ID_TOKEN, idToken)
  }
}

function eraseCookie(name: string) {
  document.cookie = name + '=;path=/;domain=flecto.io;Max-Age=0;'
}

export const clearStoreToken = () => {
  const bearerName = getBearerSetter()
  const idTokenName = getIdTokenSetter()
  const LOCALSTORAGE_SAAS_TOKEN = `${getTokenEnvironment()}_bearer_token`
  const LOCALSTORAGE_ID_TOKEN = `${getTokenEnvironment()}_id_token`

  localStorage.removeItem(LOCALSTORAGE_SAAS_TOKEN)
  localStorage.removeItem(LOCALSTORAGE_ID_TOKEN)
  eraseCookie(bearerName)
  eraseCookie(idTokenName)
}

export const claimStoredTokens = () => {
  const bearerName = getBearerSetter()
  const idTokenName = getIdTokenSetter()
  const LOCALSTORAGE_SAAS_TOKEN = `${getTokenEnvironment()}_bearer_token`
  const LOCALSTORAGE_ID_TOKEN = `${getTokenEnvironment()}_id_token`

  if (isNative || isVercelApp) {
    return {
      bearerToken: localStorage.getItem(LOCALSTORAGE_SAAS_TOKEN),
      idToken: localStorage.getItem(LOCALSTORAGE_ID_TOKEN),
    }
  }

  return {
    bearerToken: getCookie(bearerName),
    idToken: getCookie(idTokenName),
  }
}
